import { z } from "zod";

import { requiredString } from "@/common/components/forms/schema";

const emailEntrySchema = z.object({
  email: requiredString().email("reset.email.error.format"),
});

type EmailEntryFormValues = z.infer<typeof emailEntrySchema>;

const EMAIL_ENTRY_INITIAL_VALUES: EmailEntryFormValues = {
  email: "",
};

export {
  emailEntrySchema,
  EMAIL_ENTRY_INITIAL_VALUES,
  type EmailEntryFormValues,
};
